// @flow
import * as React from 'react'
import { FormattedMessage } from 'mz-intl'
import Button from '../../../core/Button'
import {
  Container,
  Message,
  ButtonContainer,
  SelectContainer,
} from './elements'
import messages from '../messages.intl'

// Types
export type Props = {
  query: string,
  onSelect?: (string) => any,
  emptyResultsMessage: React.Node | boolean,
  selectHeaderMessage: React.Node | boolean,
  selectButtonMessage: React.Node | boolean,
  disableEmptyResultsMessage?: boolean,
}

// Utils
const preventDefault = (e) => e.preventDefault()

/**
 * A component for showing empty search result. It provides a way
 * to select the query as a value when it can't be found in the
 * search results.
 */
class EmptySearchResults extends React.Component<Props> {
  static defaultProps = {
    emptyResultsMessage: true,
    selectHeaderMessage: false,
    selectButtonMessage: false,
  }

  handleSelectNonexistingValue = () => {
    const { query, onSelect } = this.props
    onSelect && onSelect(query)
  }

  renderMessages() {
    const {
      query,
      emptyResultsMessage,
      selectHeaderMessage,
      selectButtonMessage,
    } = this.props

    return {
      emptyResultsMessage:
        emptyResultsMessage !== true ? (
          emptyResultsMessage
        ) : (
          <FormattedMessage
            message={messages.NO_ITEMS_FOUND}
            values={{ query: <b>{query}</b> }}
          />
        ),
      selectHeaderMessage:
        selectHeaderMessage !== true ? (
          selectHeaderMessage
        ) : (
          <FormattedMessage
            message={messages.IM_SURE_VALUE_CORRECT_HEADER}
            values={{ query }}
          />
        ),
      selectButtonMessage:
        selectButtonMessage !== true ? (
          selectButtonMessage
        ) : (
          <FormattedMessage
            message={messages.IM_SURE_VALUE_CORRECT_BUTTON}
            values={{ query }}
          />
        ),
    }
  }

  render() {
    const { disableEmptyResultsMessage } = this.props

    const {
      emptyResultsMessage,
      selectHeaderMessage,
      selectButtonMessage,
    } = this.renderMessages()

    return (
      <Container onMouseDown={preventDefault}>
        {!disableEmptyResultsMessage && (
          <Message>{emptyResultsMessage}</Message>
        )}
        {!!(selectHeaderMessage || selectButtonMessage) && (
          <SelectContainer>
            {!!selectHeaderMessage && <Message>{selectHeaderMessage}</Message>}
            {!!selectButtonMessage && (
              <ButtonContainer>
                <Button
                  tabIndex="-1"
                  appearance="outlined"
                  onClick={this.handleSelectNonexistingValue}
                >
                  {selectButtonMessage}
                </Button>
              </ButtonContainer>
            )}
          </SelectContainer>
        )}
      </Container>
    )
  }
}

export default EmptySearchResults
